import React from "react";
import { useAppContext } from "../../helpers/account-context";
import { toPermalink } from "../../helpers/helper";
import { ResultLine, DetailLine, InfowinLine } from "./Mixin";

const CtaButton = (props) => {
  const { name, url } = props;
  const { account } = useAppContext()

  if (!name || !url) return null;
  
  return (
    <a
    href={url}
    target={account.cta_open || `_blank`}
    className={`cbmap-btn cbmap-btn-primary cbmap-cta-btn cbmap-cta-btn_${toPermalink(name)}`}
      >
      {name}
    </a> 
  );
};

export const CtaResult = (props) => {
  const { account } = useAppContext()

  const { item } = props;
  const ctaButtons = account.cta_buttons || [];
  if (ctaButtons.length === 0) return null;
  const ctaValues = item.properties.actions || [];
  if(!ctaValues || ctaValues.length === 0) return null;

  return (
    <ResultLine className="cbmap-item_custom_buttons">
      {ctaButtons.map((cta) => {
       const itemCta = ctaValues.find(
         (fd) => fd.name === cta.name
       );
       if (!itemCta) return null;
       if (!itemCta.value) return null;

       return (
        <CtaButton
          key={toPermalink(itemCta.name)}
          name={itemCta.name}
          url={itemCta.value}
        />
      )}
      )}
    </ResultLine>
  );
};

export const CtaDetail = (props) => {
  const { account } = useAppContext()

  const {
    item,
  } = props;

  const ctaButtons = account.cta_buttons || [];

  if (!ctaButtons || ctaButtons.length < 1) return null;
  const ctaValues = item.properties.actions || {};
  if(!ctaValues || ctaValues.length === 0) return null;

  return (
    <DetailLine className="cbmap-details_custom_buttons">
      {ctaButtons.map((cta) => {
       const itemCta = ctaValues.find(
         (fd) => fd.name === cta.name
       );
       if (!itemCta) return null;
       if (!itemCta.value) return null;

       return (
        <CtaButton
          key={toPermalink(itemCta.name)}
          name={itemCta.name}
          url={itemCta.value}
        />
      )}
      )}
    </DetailLine>
  );
};

export const CtaInfowin = (props) => {
  const { account } = useAppContext()

  const {
    item,
  } = props;

  const ctaButtons = account.cta_buttons || [];

  if (!ctaButtons || ctaButtons.length < 1) return null;
  const ctaValues = item.properties.actions || [];
  
  if(!ctaValues || ctaValues.length === 0) return null;

  return (
    <InfowinLine className="cbmap-infowin_custom_buttons">
      {ctaButtons.map((cta) => {
       const itemCta = ctaValues.find(
         (fd) => fd.name === cta.name
       );
       if (!itemCta) return null;
       if (!itemCta.value) return null;
       return (
        <CtaButton
          key={toPermalink(itemCta.name)}
          name={itemCta.name}
          url={itemCta.value}
        />
      )}
      )}
    </InfowinLine>
  );
};
